import AccountAttentionRail from '../components/overview/AccountAttentionRail';


import "./OverviewPage.css";

import useOverviewBooleanPreference from '../components/overview/useOverviewBooleanPreference';

import CoachDashboard from '../components/overview/CoachDashboard';
import {noteClassification} from '../utils/noteClassification';
import React, { useEffect, useMemo, useState } from "react";
import { Link,useLocation,useNavigate } from "react-router-dom";
import {HOME_PERSPECTIVE_PATHS,readHomeWorkspaceRoute} from "../utils/homeWorkspaceRoute";
import EventWorkspaceProvider from '../components/event-workspace/EventWorkspaceContext';
import HomeEventPrep from "../components/overview/HomeEventPrep";

import {
  collection,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  orderBy,
  query,
} from "firebase/firestore";

import { getDownloadURL, ref as storageRef } from "firebase/storage";

import { db, storage } from "../Security/firebase-config";
import LoginTeamGate from "../components/core-components/LoginTeamGate";
import { expandRecurring } from "../components/Calendar/recurrence";
import { useAuth } from "../context/AuthContext";
import { useTeam } from "../context/TeamContext";



import { VALORANT_MAPS } from "../components/Review/MapFolderList";
import OverviewWeeklyEvents from "../components/overview/OverviewWeeklyEvents";
import ManagerBoard from "../components/overview/ManagerBoard";


import "../components/overview/OverviewWorkspace.css";
import useOverviewViewport from '../components/overview/useOverviewViewport';
import { isReviewableVideo } from "../utils/overviewVodValidity";

const FOCUS_TREND_COLORS = ["#37d7ff", "#6e92ff", "#6bff8d"];
const FOCUS_TARGET_LIMIT = 24;

const EMPTY_WORKSPACE = {
  team: null,
  subscription: null,
  members: [],
  maps: [],
  videos: [],
  reviewMatches: [],
  upcomingEvents: [],
};

const EMPTY_INSIGHTS = {
  loading: false,
  resolved: false,
  needsReview: [],
  improvementNotes: [],
  recentFocusPoints: [],
  focusTrendSeries: [],
  focusTrendData: [],
  focusTrendItems: [],
  focusTrendTargets: [],
  focusPointCountByMap: {},
};

function safeToMillis(value) {
  if (!value) return null;

  if (
    typeof value === "object" &&
    value !== null &&
    typeof value.toDate === "function"
  ) {
    const date = value.toDate();
    return Number.isFinite(date.getTime()) ? date.getTime() : null;
  }

  if (value instanceof Date) {
    return Number.isFinite(value.getTime()) ? value.getTime() : null;
  }

  if (typeof value === "number" && Number.isFinite(value)) {
    return value > 1e12 ? value : value * 1000;
  }

  if (typeof value === "string" && value.trim()) {
    const parsed = new Date(value);
    return Number.isFinite(parsed.getTime()) ? parsed.getTime() : null;
  }

  if (typeof value?.seconds === "number") {
    return value.seconds * 1000;
  }

  return null;
}



function formatMiniDate(value) {
  const ms = safeToMillis(value);
  if (!ms) return "N/A";

  return new Intl.DateTimeFormat("en-CA", {
    day: "numeric",
    month: "short",
  }).format(new Date(ms));
}

function sortByNewest(items, getValue) {
  return [...items].sort(
    (left, right) =>
      (safeToMillis(getValue(right)) || 0) - (safeToMillis(getValue(left)) || 0)
  );
}

function truncateCopy(value, maxLength = 88) {
  const safeValue = typeof value === "string" ? value : "";
  if (safeValue.length <= maxLength) return safeValue;
  return `${safeValue.slice(0, Math.max(0, maxLength - 3)).trimEnd()}...`;
}

function resolveVideoSource(video) {
  return [
    video?.videoURL,
    video?.videoUrl,
    video?.url,
    video?.downloadURL,
    video?.downloadUrl,
    video?.mediaURL,
  ].find((value) => typeof value === "string" && value.trim()) || null;
}

function resolveVideoStoragePath(video) {
  return [video?.storagePath, video?.finalStoragePath, video?.videoStoragePath, video?.mediaStoragePath]
    .find((value) => typeof value === "string" && value.trim()) || null;
}

function resolveInlineFocusPoints(...sources) {
  return sources.find((value) => Array.isArray(value)) || [];
}

function shouldShowReviewVideo(video) {
  return isReviewableVideo(video);
}

function normalizeDesktopDraftFocusPointRatings(value) {
  const ratings = {};

  const addRating = (username, rawRating, fallbackIndex = null) => {
    const normalizedUsername =
      typeof username === "string" ? username.trim() : String(username || "").trim();
    const rating = Number(rawRating);
    const key = normalizedUsername || (fallbackIndex == null ? "legacy" : `legacy-${fallbackIndex}`);

    if (!Number.isFinite(rating) || rating < 1 || rating > 5) {
      return;
    }

    ratings[key] = Math.round(rating);
  };

  if (typeof value === "number" || typeof value === "string") {
    addRating("legacy", value);
    return ratings;
  }

  if (Array.isArray(value)) {
    value.forEach((entry, index) => {
      if (entry && typeof entry === "object") {
        addRating(
          entry.username || entry.user || entry.name || entry.uid || "",
          entry.rating ?? entry.value ?? entry.score,
          index,
        );
        return;
      }

      addRating("", entry, index);
    });
    return ratings;
  }

  if (!value || typeof value !== "object") {
    return ratings;
  }

  Object.entries(value).forEach(([username, rawRating]) => {
    addRating(username, rawRating);
  });

  return ratings;
}

async function loadOrderedDocs(pathSegments) {
  const targetCollection = collection(db, ...pathSegments);

  try {
    const orderedSnapshot = await getDocs(query(targetCollection, orderBy("order", "asc")));
    return orderedSnapshot.docs.map((snapshot) => ({
      id: snapshot.id,
      ...snapshot.data(),
    }));
  } catch (_) {
    const fallbackSnapshot = await getDocs(targetCollection);
    return fallbackSnapshot.docs.map((snapshot) => ({
      id: snapshot.id,
      ...snapshot.data(),
    }));
  }
}

async function computeUnreviewedForMatch({ teamId, mapId, matchId, username }) {
  if (!teamId || !mapId || !matchId || !username) return 0;

  let unreviewed = 0;

  const notesRef = collection(db, "teams", teamId, "maps", mapId, "matches", matchId, "notes");
  const notesSnap = await getDocs(notesRef);

  notesSnap.docs.forEach((noteDoc) => {
    const note = noteDoc.data() || {};
    const mentions = Array.isArray(note.at) ? note.at : [];
    const relevantToUser =
      mentions.includes("@Team") || mentions.includes(`@${username}`);
    const userHasNotViewed =
      !Array.isArray(note.viewers) || !note.viewers.includes(username);

    if (relevantToUser && userHasNotViewed) {
      unreviewed += 1;
    }
  });

  const repliesRef = collection(
    db,
    "teams",
    teamId,
    "maps",
    mapId,
    "matches",
    matchId,
    "allReplies"
  );
  const repliesSnap = await getDocs(repliesRef);

  repliesSnap.docs.forEach((replyDoc) => {
    const reply = replyDoc.data() || {};
    const viewers = Array.isArray(reply.viewers) ? reply.viewers : [];
    const notViewedByMe = !viewers.includes(username);
    const notMyReply = reply.createdBy !== username;

    if (notViewedByMe && notMyReply) {
      unreviewed += 1;
    }
  });

  return unreviewed;
}

async function computeUnreviewedForLegacyVideo({ teamId, mapId, videoId, username }) {
  if (!teamId || !mapId || !videoId || !username) return 0;

  let unreviewed = 0;

  const notesRef = collection(db, "teams", teamId, "maps", mapId, "videos", videoId, "notes");
  const notesSnap = await getDocs(notesRef);

  notesSnap.docs.forEach((noteDoc) => {
    const note = noteDoc.data() || {};
    const mentions = Array.isArray(note.at) ? note.at : [];
    const relevantToUser =
      mentions.includes("@Team") || mentions.includes(`@${username}`);
    const userHasNotViewed =
      !Array.isArray(note.viewers) || !note.viewers.includes(username);

    if (relevantToUser && userHasNotViewed) {
      unreviewed += 1;
    }
  });

  const repliesRef = collection(
    db,
    "teams",
    teamId,
    "maps",
    mapId,
    "videos",
    videoId,
    "allReplies"
  );
  const repliesSnap = await getDocs(repliesRef);

  repliesSnap.docs.forEach((replyDoc) => {
    const reply = replyDoc.data() || {};
    const viewers = Array.isArray(reply.viewers) ? reply.viewers : [];
    const notViewedByMe = !viewers.includes(username);
    const notMyReply = reply.createdBy !== username;

    if (notViewedByMe && notMyReply) {
      unreviewed += 1;
    }
  });

  return unreviewed;
}

function buildReviewTargets(videos) {
  const targets = new Map();

  videos.forEach((video) => {
    const key = video.matchId
      ? `match:${video.mapId}:${video.matchId}`
      : `video:${video.mapId}:${video.id}`;
    const dateValue = video.matchPlayedAt || video.createdAt || null;
    const existing = targets.get(key);

    if (!existing) {
      targets.set(key, {
        key,
        mapId: video.mapId,
        mapName: video.mapName,
        title: video.matchTitle || video.title || "Untitled VOD",
        subtitle: video.matchId
          ? `${video.mapName} | 1 POV`
          : `${video.mapName} | ${video.povName || "POV"}`,
        dateValue,
        matchId: video.matchId || null,
        videoId: video.id,
        linked: video.linkedTeamStats === true,
        videoCount: 1,
        status: video.status || "ready",
        inlineFocusPoints: resolveInlineFocusPoints(video.inlineFocusPoints),
      });
      return;
    }

    existing.videoCount += 1;
    existing.linked = existing.linked || video.linkedTeamStats === true;
    existing.status =
      existing.status === "processing" || video.status === "processing"
        ? "processing"
        : existing.status;
    if (!existing.inlineFocusPoints.length && Array.isArray(video.inlineFocusPoints)) {
      existing.inlineFocusPoints = video.inlineFocusPoints;
    }

    const nextDateMs = safeToMillis(dateValue) || 0;
    const currentDateMs = safeToMillis(existing.dateValue) || 0;

    if (nextDateMs > currentDateMs) {
      existing.dateValue = dateValue;
      existing.videoId = video.id;

      if (!existing.matchId) {
        existing.title = video.title || existing.title;
      }
    }
  });

  return Array.from(targets.values())
    .map((target) => ({
      ...target,
      subtitle: target.matchId
        ? `${target.mapName} | ${target.videoCount} POV${
            target.videoCount === 1 ? "" : "s"
          }`
        : target.subtitle,
    }))
    .sort(
      (left, right) =>
        (safeToMillis(right.dateValue) || 0) - (safeToMillis(left.dateValue) || 0)
    );
}

function normalizeImprovementNotes(raw, scope, priority) {
  return raw
    .map((entry, index) => ({
      id: String(entry.id || `${scope}-${index + 1}`),
      scope,
      classification: noteClassification(entry, {scope:priority ? "map" : "general",mapName:priority ? scope : ""}),
      text: typeof entry.text === "string" ? entry.text.trim() : "",
      archived: entry.archived === true,
      order:
        typeof entry.order === "number" && Number.isFinite(entry.order)
          ? entry.order
          : index,
      priority,
    }))
    .filter((entry) => entry.text.length > 0 && entry.archived === false)
    .sort((left, right) => left.order - right.order)
    .map(({ archived, order, ...entry }) => entry);
}

function buildFocusTargetEntries(targets) {
  return targets.slice(0, FOCUS_TARGET_LIMIT);
}

function buildFocusTargets(reviewTargets, reviewMatches) {
  const targets = new Map(
    reviewTargets.map((target) => [
      target.key,
      {
        ...target,
        inlineFocusPoints: resolveInlineFocusPoints(target.inlineFocusPoints),
      },
    ]),
  );

  reviewMatches.forEach((match) => {
    if (!match?.id || !match?.mapId) {
      return;
    }

    const key = `match:${match.mapId}:${match.id}`;
    const existing = targets.get(key);

    if (existing) {
      if (!existing.inlineFocusPoints.length && Array.isArray(match.inlineFocusPoints)) {
        existing.inlineFocusPoints = match.inlineFocusPoints;
      }
      return;
    }

    targets.set(key, {
      key,
      mapId: match.mapId,
      mapName: match.mapName,
      title: match.title || "Untitled VOD",
      subtitle: `${match.mapName} | Match`,
      dateValue: match.dateValue || null,
      matchId: match.id,
      videoId: null,
      linked: false,
      videoCount: 0,
      status: "ready",
      inlineFocusPoints: resolveInlineFocusPoints(match.inlineFocusPoints),
    });
  });

  return buildFocusTargetEntries(
    sortByNewest(Array.from(targets.values()), (target) => target.dateValue),
  );
}

function buildFocusTrendInsights(targets) {
  const flattened = targets
    .flatMap((target) => target.points)
    .sort((left, right) => right.dateMs - left.dateMs);

  const focusPointCountByMap = flattened.reduce((counts, point) => {
    if (!point.mapId) return counts;
    counts[point.mapId] = (counts[point.mapId] || 0) + 1;
    return counts;
  }, {});

  const recurring = new Map();

  flattened.forEach((point) => {
    const existing = recurring.get(point.normalizedText) || {
      label: point.text,
      count: 0,
      ratedCount: 0,
      lastSeen: 0,
    };

    existing.count += 1;
    if (typeof point.avgRating === "number") {
      existing.ratedCount += 1;
    }
    existing.lastSeen = Math.max(existing.lastSeen, point.dateMs);
    recurring.set(point.normalizedText, existing);
  });

  const focusTrendSeries = Array.from(recurring.entries())
    .sort((left, right) => {
      const ratedDelta = right[1].ratedCount - left[1].ratedCount;
      if (ratedDelta !== 0) return ratedDelta;

      const countDelta = right[1].count - left[1].count;
      if (countDelta !== 0) return countDelta;

      return right[1].lastSeen - left[1].lastSeen;
    })
    .filter(([, entry]) => entry.ratedCount > 0)
    .slice(0, 3)
    .map(([key, entry], index) => ({
      key,
      label: truncateCopy(entry.label, 24),
      color: FOCUS_TREND_COLORS[index] || "#37d7ff",
    }));

  const focusTrendData = sortByNewest(targets, (target) => target.dateValue)
    .slice(0, 24)
    .reverse()
    .map((target) => {
      const pointMap = new Map(
        target.points.map((point) => [point.normalizedText, point])
      );

      return {
        id: target.key,
        label: formatMiniDate(target.dateValue),
        title: target.title,
        dateMs: safeToMillis(target.dateValue) || 0,
        mapId: target.mapId,
        mapName: target.mapName,
        values: focusTrendSeries.reduce((values, series) => {
          values[series.key] = pointMap.get(series.key)?.avgRating ?? null;
          return values;
        }, {}),
      };
    });

  const focusTrendItems = focusTrendSeries.map((series) => {
    const latestPoint =
      flattened.find((point) => point.normalizedText === series.key) || null;

    return {
      key: series.key,
      label: series.label,
      color: series.color,
      text: latestPoint?.text || series.label,
      classification: latestPoint?.classification,
      targetTitle: latestPoint?.targetTitle || "Recent VOD",
      targetLabel: latestPoint?.targetLabel || "Recent review cycle",
      mapName: latestPoint?.mapName || series.label,
      avgRating: latestPoint?.avgRating ?? null,
      ratingCount: latestPoint?.ratingCount ?? 0,
      dateMs: latestPoint?.dateMs || 0,
    };
  });

  const fallbackFocusItems =
    focusTrendItems.length > 0
      ? focusTrendItems
      : flattened.slice(0, 5).map((point, index) => ({
          key: `recent-${point.id}`,
          label: truncateCopy(point.text, 24),
          color: FOCUS_TREND_COLORS[index % FOCUS_TREND_COLORS.length] || "#37d7ff",
          text: point.text,
          ...noteClassification(point),
          targetTitle: point.targetTitle,
          targetLabel: point.targetLabel,
          mapName: point.mapName,
          avgRating: point.avgRating,
          ratingCount: point.ratingCount,
          dateMs: point.dateMs || 0,
        }));

  return {
    recentFocusPoints: flattened.slice(0, 5),
    focusTrendTargets: targets,
    focusTrendSeries,
    focusTrendData,
    focusTrendItems: fallbackFocusItems,
    focusPointCountByMap,
  };
}

function buildLinePath(values, xFor, yFor) {
  let path = "";
  let drawing = false;

  values.forEach((value, index) => {
    if (typeof value !== "number") {
      drawing = false;
      return;
    }

    const segment = `${xFor(index)} ${yFor(value)}`;
    if (!drawing) {
      path += `${path ? " " : ""}M ${segment}`;
      drawing = true;
      return;
    }

    path += ` L ${segment}`;
  });

  return path;
}







function buildUpcomingEvents(rawEvents) {
  const now = new Date();
  const horizon = new Date(now.getTime() + 1000 * 60 * 60 * 24 * 60);

  return expandRecurring(rawEvents || [], now, horizon)
    .filter((event) => {
      const startMs = safeToMillis(event.startUTC);
      const endMs = safeToMillis(event.endUTC);
      return Boolean(startMs && endMs && endMs > Date.now());
    })
    .map((event) => {
      const participants = Array.isArray(event.participants)
        ? event.participants
            .map((value) => (typeof value === "string" ? value.trim() : ""))
            .filter(Boolean)
        : [];

      return {
        eventId: event.eventId || event.id || `${event.tag || "event"}-${event.startUTC}`,
        tag:
          typeof event.tag === "string" && event.tag.trim()
            ? event.tag.trim()
            : "Team event",
        note:
          typeof event.note === "string" && event.note.trim()
            ? event.note.trim()
            : "",
        startUTC: event.startUTC,
        endUTC: event.endUTC,
        participants,
        participantCount: participants.length,
        repeat:
          typeof event.repeat === "string" && event.repeat.trim() && event.repeat !== "none"
            ? event.repeat.trim()
            : null,
      };
    })
    .sort(
      (left, right) =>
        (safeToMillis(left.startUTC) || 0) - (safeToMillis(right.startUTC) || 0)
    )
    .slice(0, 4);
}

async function getUsernameByUid(uid) {
  if (!uid) return "Member";

  try {
    const directorySnapshot = await getDoc(doc(db, "uids", uid));
    if (!directorySnapshot.exists()) {
      return "Member";
    }

    const data = directorySnapshot.data() || {};
    return data.username || "Member";
  } catch (_) {
    return "Member";
  }
}

async function resolveMemberUsernames(memberUids) {
  return Promise.all(
    (Array.isArray(memberUids) ? memberUids : []).map(async (uid) => ({
      uid,
      username: await getUsernameByUid(uid),
    }))
  );
}

async function resolvePendingMembers(pendingJoins) {
  const pendingJoinIds =
    pendingJoins && typeof pendingJoins === "object"
      ? Object.keys(pendingJoins).filter(
          (uid) => typeof uid === "string" && uid.trim().length > 0
        )
      : [];

  return Promise.all(
    pendingJoinIds.map(async (uid) => ({
      uid,
      username: await getUsernameByUid(uid),
      pendingStatus: pendingJoins?.[uid]?.status || "pending",
    }))
  );
}

function useOverviewWorkspace(teamId) {
  const [workspace, setWorkspace] = useState(EMPTY_WORKSPACE);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    let revision = 0;
    let reloadTimer;
    let hasLoaded = false;
    const snapshots = new Map();
    const subscriptions = new Map();
    setWorkspace(EMPTY_WORKSPACE);

    function watch(path, onChange) {
      if (cancelled || subscriptions.has(path)) return;
      subscriptions.set(path, onSnapshot(collection(db, path), snapshot => {
        if (cancelled) return;
        snapshots.set(path, snapshot);
        onChange?.(snapshot);
        revision += 1;
        clearTimeout(reloadTimer);
        reloadTimer = setTimeout(() => { void loadWorkspace(); }, 100);
      }, watchError => {
        if (!cancelled) setError(watchError.message || "Could not sync the overview.");
      }));
    }

    async function loadWorkspace() {
      const loadRevision = revision;
      if (!teamId) {
        if (!cancelled) {
          setWorkspace(EMPTY_WORKSPACE);
          setLoading(false);
          setError(null);
        }
        return;
      }

      setLoading(!hasLoaded);
      setError(null);

      try {
        const teamSnapshot = await getDoc(doc(db, "teams", teamId));
        if (!teamSnapshot.exists()) {
          throw new Error("The selected team could not be found.");
        }

        const teamData = teamSnapshot.data() || {};
        const [members, pendingMembers, teamLeaderUsername, subscriptionSnapshot] =
          await Promise.all([
            resolveMemberUsernames(teamData.members),
            resolvePendingMembers(teamData.pendingJoins),
            getUsernameByUid(teamData.teamLeaderId),
            getDoc(doc(db, "teams", teamId, "billingV2", "subscription")),
          ]);

        const subscription = subscriptionSnapshot.exists()
          ? { id: subscriptionSnapshot.id, ...(subscriptionSnapshot.data() || {}) }
          : null;

        const mapsSnapshot = await getDocs(collection(db, "teams", teamId, "maps"));
        const savedMaps = mapsSnapshot.docs.map((snapshot) => {
          const data = snapshot.data() || {};
          return {
            id: snapshot.id,
            name:
              data.name ||
              data.mapName ||
              data.title ||
              snapshot.id,
          };
        });
        const mapsById = new Map(
          VALORANT_MAPS.map((mapName) => [mapName, { id: mapName, name: mapName }]),
        );
        savedMaps.forEach((map) => mapsById.set(map.id, map));
        const maps = Array.from(mapsById.values());
        watch(`teams/${teamId}/maps`);
        watch(`teams/${teamId}/matches`);
        maps.forEach(map => {
          watch(`teams/${teamId}/maps/${map.id}/matches`);
          watch(`teams/${teamId}/maps/${map.id}/videos`, snapshot => {
            const liveIds = new Set(snapshot.docs.filter(item => shouldShowReviewVideo(item.data())).map(item => item.id));
            setWorkspace(current => ({...current, videos: current.videos.filter(video => video.mapId !== map.id || liveIds.has(video.id))}));
          });
        });

        const reviewDataByMap = await Promise.all(
          maps.map(async (map) => {
            const [videoSnapshot, matchSnapshot] = await Promise.all([
              snapshots.get(`teams/${teamId}/maps/${map.id}/videos`) || getDocs(collection(db, "teams", teamId, "maps", map.id, "videos")),
              snapshots.get(`teams/${teamId}/maps/${map.id}/matches`) || getDocs(collection(db, "teams", teamId, "maps", map.id, "matches")),
            ]);

            const matchMetaById = matchSnapshot.docs.reduce((accumulator, snapshot) => {
              accumulator[snapshot.id] = snapshot.data() || {};
              return accumulator;
            }, {});

            const reviewMatches = matchSnapshot.docs.map((snapshot) => {
              const data = snapshot.data() || {};
              return {
                id: snapshot.id,
                mapId: map.id,
                mapName: map.name,
                title:
                  (typeof data.title === "string" && data.title.trim()) ||
                  (typeof data.matchTitle === "string" && data.matchTitle.trim()) ||
                  (typeof data.name === "string" && data.name.trim()) ||
                  "Untitled VOD",
                dateValue:
                  data.matchPlayedAt ||
                  data.createdAt ||
                  data.startedAt ||
                  data.updatedAt ||
                  null,
                inlineFocusPoints: resolveInlineFocusPoints(
                  data.focusPoints,
                  data.focusPointRatings,
                ),
              };
            });

            const resolvedVideos = await Promise.all(
              videoSnapshot.docs.map(async (snapshot) => {
                const data = snapshot.data() || {};
                if (!shouldShowReviewVideo(data)) {
                  return null;
                }

                const matchId = [data.matchId, data.matchID, data.reviewMatchId]
                  .find((value) => typeof value === "string" && value.trim()) || null;
                const matchMeta = matchId ? matchMetaById[matchId] || {} : {};
                const videoURL = resolveVideoSource(data);
                const storagePath = resolveVideoStoragePath(data);
                let downloadUrl = videoURL;

                const storageTarget = storagePath || (/^https:\/\/(firebasestorage\.googleapis\.com|storage\.googleapis\.com)\//.test(videoURL || '') ? videoURL : null);
                if (storageTarget) {
                  try {
                    downloadUrl = await getDownloadURL(
                      storageRef(storage, storageTarget)
                    );
                  } catch (storageError) {
                    if (storageError.code === "storage/object-not-found") return null;
                  }
                }

                return {
                  id: snapshot.id,
                  mapId: map.id,
                  mapName: map.name,
                  title:
                    (typeof data.title === "string" && data.title.trim()) ||
                    (typeof data.fileName === "string" && data.fileName.trim()) ||
                    (typeof data.name === "string" && data.name.trim()) ||
                    "Untitled VOD",
                  povName:
                    (typeof data.povName === "string" && data.povName.trim()) ||
                    (typeof data.pov === "string" && data.pov.trim()) ||
                    (typeof data.playerName === "string" && data.playerName.trim()) ||
                    "POV",
                  createdBy:
                    (typeof data.createdBy === "string" && data.createdBy.trim()) ||
                    (typeof data.uploadedBy === "string" && data.uploadedBy.trim()) ||
                    (typeof data.uploader === "string" && data.uploader.trim()) ||
                    "Unknown",
                  createdByUid:
                    typeof data.createdByUid === "string" && data.createdByUid.trim()
                      ? data.createdByUid.trim()
                      : null,
                  createdAt: data.createdAt || data.uploadedAt || data.timestamp || data.updatedAt || null,
                  matchId,
                  matchTitle:
                    (typeof matchMeta.title === "string" && matchMeta.title.trim()) ||
                    (typeof matchMeta.matchTitle === "string" && matchMeta.matchTitle.trim()) ||
                    (typeof matchMeta.name === "string" && matchMeta.name.trim()) ||
                    null,
                  matchPlayedAt:
                    matchMeta.matchPlayedAt ||
                    matchMeta.createdAt ||
                    matchMeta.startedAt ||
                    data.matchPlayedAt ||
                    null,
                  status:
                    (typeof data.status === "string" && data.status.trim()) ||
                    (typeof data.processingStatus === "string" && data.processingStatus.trim()) ||
                    "ready",
                  storagePath,
                  downloadUrl,
                  videoURL,
                  linkedTeamStats:
                    (Array.isArray(matchMeta.linkedTeamStats) &&
                      matchMeta.linkedTeamStats.length > 0) ||
                    (Array.isArray(data.linkedTeamStats) &&
                      data.linkedTeamStats.length > 0) ||
                    Boolean(data.teamStatsImageUrl || data.teamStatsImageStoragePath),
                  isStorageOnly: Boolean(storagePath) && !videoURL,
                  inlineFocusPoints: resolveInlineFocusPoints(
                    matchMeta.focusPoints,
                    data.focusPoints,
                    data.focusPointRatings,
                  ),
                };
              })
            );

            return {
              videos: resolvedVideos.filter(Boolean),
              reviewMatches: reviewMatches.filter(match => resolvedVideos.some(video => video?.matchId === match.id)),
            };
          })
        );

        const nextWorkspace = {
          team: {
            id: teamId,
            events: teamData.events || [],
            name:
              teamData.teamName ||
              teamData.name ||
              "Selected team workspace",
            teamLeaderId: teamData.teamLeaderId || null,
            teamLeaderUsername,
            teamRegion: teamData.teamRegion || "Region TBD",
            teamTimeZone:
              teamData.teamTimeZone ||
              Intl.DateTimeFormat().resolvedOptions().timeZone ||
              "UTC",
            pendingMembers,
            memberCount: members.length,
          },
          subscription,
          members,
          maps,
          videos: reviewDataByMap.flatMap((entry) => entry.videos),
          reviewMatches: reviewDataByMap.flatMap((entry) => entry.reviewMatches),
          upcomingEvents: buildUpcomingEvents(teamData.events),
        };

        if (!cancelled && revision === loadRevision) {
          hasLoaded = true;
          setWorkspace(nextWorkspace);
          setLoading(false);
          setError(null);
        }
      } catch (loadError) {
        if (!cancelled && revision === loadRevision) {
          setWorkspace(EMPTY_WORKSPACE);
          setLoading(false);
          setError(loadError?.message || "Could not load the overview workspace.");
        }
      }
    }

    // Calendar events live on the team document. Keep Coach data current when
    // scheduling in Manager without unmounting the shared Home workspace.
    const stopTeam = teamId ? onSnapshot(doc(db, 'teams', teamId), () => {
      revision += 1;
      clearTimeout(reloadTimer);
      reloadTimer = setTimeout(() => { void loadWorkspace(); }, 100);
    }, watchError => {
      if (!cancelled) setError(watchError.message || 'Could not sync the team.');
    }) : () => {};
    void loadWorkspace();

    return () => {
      cancelled = true;
      stopTeam();
      clearTimeout(reloadTimer);
      subscriptions.forEach(unsubscribe => unsubscribe());
    };
  }, [teamId]);

  return {
    workspace,
    loading,
    error,
  };
}









function FocusTrendChart({ data, series, hasFocusPoints }) {
  const width = 520;
  const height = 192;
  const padding = { top: 14, right: 18, bottom: 30, left: 28 };
  const innerWidth = width - padding.left - padding.right;
  const innerHeight = height - padding.top - padding.bottom;
  const xFor = (index) =>
    data.length > 1
      ? padding.left + (innerWidth / (data.length - 1)) * index
      : padding.left + innerWidth / 2;
  const yFor = (value) => padding.top + innerHeight - (((value - 1) / 4) * innerHeight);
  const yTicks = [1, 2, 3, 4, 5];

  return (
    <div className="desktop-overview-b__trend-shell">
      <svg
        className="desktop-overview-b__trend-chart"
        viewBox={`0 0 ${width} ${height}`}
        role="img"
        aria-label="Focus point improvement trend across recent VODs"
      >
        {yTicks.map((tick) => (
          <g key={tick}>
            <line
              x1={padding.left}
              x2={width - padding.right}
              y1={yFor(tick)}
              y2={yFor(tick)}
              className="desktop-overview-b__trend-grid-line"
            />
            <text
              x={padding.left - 10}
              y={yFor(tick) + 4}
              textAnchor="end"
              className="desktop-overview-b__trend-grid-label"
            >
              {tick}
            </text>
          </g>
        ))}

        {series.map((entry) => {
          const values = data.map((datum) => datum.values[entry.key] ?? null);
          const path = buildLinePath(values, xFor, yFor);

          return (
            <g key={entry.key}>
              {path ? (
                <path
                  d={path}
                  fill="none"
                  stroke={entry.color}
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              ) : null}

              {values.map((value, index) =>
                typeof value === "number" ? (
                  <circle
                    key={`${entry.key}-${data[index]?.id || index}`}
                    cx={xFor(index)}
                    cy={yFor(value)}
                    r="4"
                    fill={entry.color}
                    className="desktop-overview-b__trend-dot"
                  >
                    <title>{`${entry.label}: ${value.toFixed(1)} in ${data[index]?.title || "recent VOD"}`}</title>
                  </circle>
                ) : null
              )}
            </g>
          );
        })}

        <line x1={padding.left} x2={width - padding.right} y1={yFor(1)} y2={yFor(1)} className="desktop-overview-b__trend-grid-line" />
        {!data.length && <text x={padding.left + innerWidth / 2} y={height - 10} textAnchor="middle" className="desktop-overview-b__trend-axis-label">Recent VODs</text>}
        {data.map((datum, index) => (
          <text
            key={datum.id}
            x={xFor(index)}
            y={height - 10}
            textAnchor="middle"
            className="desktop-overview-b__trend-axis-label"
          >
            {datum.label}
          </text>
        ))}
      </svg>
      {!hasFocusPoints && <p className="desktop-overview-b__trend-empty-message">This team does not have any focus points saved yet. Once saved, they will be displayed here.</p>}
    </div>
  );
}

export default function OverviewPage({eventWorkspaceLocalPlayer}={}) {
  return <EventWorkspaceProvider LocalPlayer={eventWorkspaceLocalPlayer}><HomeWorkspaceContent/></EventWorkspaceProvider>;
}

function HomeWorkspaceContent() {
  const pageRef=useOverviewViewport();
  const location=useLocation(),navigate=useNavigate();
  const route=useMemo(()=>readHomeWorkspaceRoute(location),[location]);
  const overviewMode=route.perspective,workspaceScheduleMode=route.view;
  const [contextRail,setContextRail]=useState(null);
  const [coachControlsTarget,setCoachControlsTarget]=useState(null);
  const go=(perspective,changes={})=>{
    const params=new URLSearchParams(location.search);params.delete('prep');params.delete('event');params.delete('view');
    Object.entries(changes).forEach(([key,value])=>{if(value)params.set(key,value);else params.delete(key);});
    navigate({pathname:HOME_PERSPECTIVE_PATHS[perspective],search:params.toString()?'?'+params.toString():''});
  };
  const setOverviewMode=mode=>go(mode);
  const setWorkspaceScheduleMode=mode=>go('workspace',{view:mode==='personal'?'personal':'events'});
  const managerNavigation=useMemo(()=>route.availability?route.navigation:null,[route]);
  const { userData, loading: authLoading } = useAuth();
  const [highlightParticipation,setHighlightParticipation]=useOverviewBooleanPreference(userData?.uid,'highlightParticipation',true);
  const navigateAvailability=(mode,context)=>{
    if(mode==='team')go('manager',{view:'availability',teamId:context?.teamId,date:context?.date,zone:context?.zone});
    else setWorkspaceScheduleMode(mode==='personal'?'personal':'events');
  };
  const {
    teamId: activeTeamId,
    username: teamContextUsername,
    loading: teamLoading,
  } = useTeam();
  // Rail tasks can belong to another team. Keep the Coach's data and widgets
  // scoped to that deep link rather than silently opening the sidebar's team.
  const teamId = overviewMode === 'coach' ? route.navigation.teamId || activeTeamId : activeTeamId;
  const { workspace, loading: workspaceLoading, error } = useOverviewWorkspace(teamId);

  const currentUsername = useMemo(() => {
    const preferred =
      (typeof userData?.username === "string" && userData.username.trim()) ||
      (typeof teamContextUsername === "string" && teamContextUsername.trim()) ||
      "Member";

    return preferred;
  }, [teamContextUsername, userData?.username]);

  const { team, videos, reviewMatches, maps } =
    workspace;
  const normalizedCurrentUsername =
    currentUsername.trim().toLowerCase() === "member" ? "" : currentUsername.trim();
  const sortedVideos = useMemo(
    () => sortByNewest(videos, (video) => video.matchPlayedAt || video.createdAt),
    [videos]
  );
  const reviewTargets = useMemo(
    () => buildReviewTargets(sortedVideos.slice(0, 12)),
    [sortedVideos]
  );
  const focusTargets = useMemo(
    () => buildFocusTargets(reviewTargets, reviewMatches),
    [reviewMatches, reviewTargets]
  );
  const noteMapIds = useMemo(
    () => Array.from(new Set(maps.map((map) => map.id))).filter(Boolean),
    [maps]
  );
  const [insights, setInsights] = useState(EMPTY_INSIGHTS);
  const [selectedImprovementNoteMap, setSelectedImprovementNoteMap] = useState("General");
  const improvementNoteScopes = useMemo(
    () => [
      { value: "General", label: "General", mapId: null, focusPointCount: null },
      ...maps.map((map) => {
        const label = map.name || map.mapName || map.id;
        return {
          value: label,
          label,
          mapId: map.id,
          focusPointCount: insights.focusPointCountByMap[map.id] || 0,
        };
      }),
    ],
    [insights.focusPointCountByMap, maps],
  );

  useEffect(() => {
    if (!improvementNoteScopes.some((scope) => scope.value === selectedImprovementNoteMap)) {
      setSelectedImprovementNoteMap("General");
    }
  }, [improvementNoteScopes, selectedImprovementNoteMap]);

  const reviewTargetSignature = useMemo(
    () =>
      reviewTargets
        .map(
          (target) =>
            `${target.key}:${safeToMillis(target.dateValue) || 0}:${target.linked ? "1" : "0"}`
        )
        .join("|"),
    [reviewTargets]
  );
  const focusTargetSignature = useMemo(
    () =>
      focusTargets
        .map((target) => `${target.key}:${safeToMillis(target.dateValue) || 0}`)
        .join("|"),
    [focusTargets]
  );
  const noteMapSignature = useMemo(() => noteMapIds.join("|"), [noteMapIds]);

  useEffect(() => {
    let cancelled = false;

    async function loadOverviewInsights() {
      if (!team?.id) {
        if (!cancelled) {
          setInsights(EMPTY_INSIGHTS);
        }
        return;
      }

      setInsights((current) => ({ ...current, loading: true }));

      try {
        const [needsReview, improvementNotes, focusTrendPayload] = await Promise.all([
          normalizedCurrentUsername
            ? Promise.allSettled(
                reviewTargets.map(async (target) => {
                  const unreviewedCount = target.matchId
                    ? await computeUnreviewedForMatch({
                        teamId: team.id,
                        mapId: target.mapId,
                        matchId: target.matchId,
                        username: normalizedCurrentUsername,
                      })
                    : await computeUnreviewedForLegacyVideo({
                        teamId: team.id,
                        mapId: target.mapId,
                        videoId: target.videoId,
                        username: normalizedCurrentUsername,
                      });

                  return {
                    ...target,
                    unreviewedCount,
                  };
                })
              ).then((results) =>
                results
                  .flatMap((result) => result.status === "fulfilled" ? [result.value] : [])
                  .filter((item) => item.unreviewedCount > 0)
                  .sort((left, right) => {
                    const countDelta = right.unreviewedCount - left.unreviewedCount;
                    if (countDelta !== 0) return countDelta;
                    return (safeToMillis(right.dateValue) || 0) - (safeToMillis(left.dateValue) || 0);
                  })
                  .slice(0, 12)
              )
            : Promise.resolve([]),
          (async () => {
            const [generalRaw, mapSettled] = await Promise.all([
              loadOrderedDocs(["teams", team.id, "generalSummaryFocusPoints"]).catch(() => []),
              Promise.allSettled(
                noteMapIds.map(async (mapId) => ({
                  mapId,
                  raw: await loadOrderedDocs([
                    "teams",
                    team.id,
                    "maps",
                    mapId,
                    "summaryFocusPoints",
                  ]),
                }))
              ),
            ]);

            const generalNotes = normalizeImprovementNotes(generalRaw, "General", 0);
            const mapNameById = new Map(maps.map((map) => [map.id, map.name]));
            const mapNotes = mapSettled.flatMap((result) => {
              if (result.status !== "fulfilled") {
                return [];
              }

              const scopeLabel = mapNameById.get(result.value.mapId) || result.value.mapId;
              return normalizeImprovementNotes(result.value.raw, scopeLabel, 1);
            });

            return [...generalNotes, ...mapNotes].sort((left, right) => {
              const priorityDelta = left.priority - right.priority;
              if (priorityDelta !== 0) return priorityDelta;
              return left.scope.localeCompare(right.scope);
            });
          })(),
          (async () => {
            const focusResults = await Promise.allSettled(
              focusTargets.map(async (target) => {
                let rawPoints = [];

                try {
                  rawPoints = await loadOrderedDocs(
                    target.matchId
                      ? [
                          "teams",
                          team.id,
                          "maps",
                          target.mapId,
                          "matches",
                          target.matchId,
                          "focusPoints",
                        ]
                      : [
                          "teams",
                          team.id,
                          "maps",
                          target.mapId,
                          "videos",
                          target.videoId,
                          "focusPoints",
                        ]
                  );
                } catch (_) {
                  rawPoints = [];
                }

                if (!rawPoints.length && Array.isArray(target.inlineFocusPoints)) {
                  rawPoints = target.inlineFocusPoints;
                }
                const dateMs = safeToMillis(target.dateValue) || 0;
                const targetLabel = `${target.mapName} | ${formatMiniDate(target.dateValue)}`;

                const points = rawPoints
                  .map((entry, index) => {
                    const text = typeof entry.text === "string" ? entry.text.trim() : "";
                    if (!text) return null;

                    const ratings = normalizeDesktopDraftFocusPointRatings(
                      entry.ratings ?? entry.rating
                    );
                    const ratingValues = Object.values(ratings);
                    const avgRating = ratingValues.length
                      ? Number(
                          (
                            ratingValues.reduce((sum, value) => sum + value, 0) /
                            ratingValues.length
                          ).toFixed(2)
                        )
                      : null;

                    return {
                      id: `${target.key}:${String(entry.id || index)}`,
                      normalizedText: text.toLowerCase(),
                      classification: noteClassification(entry),
                      text,
                      targetKey: target.key,
                      targetTitle: target.title,
                      targetLabel,
                      mapName: target.mapName,
                      dateMs,
                      avgRating,
                      ratingCount: ratingValues.length,
                      mapId: target.mapId,
                    };
                  })
                  .filter(Boolean);

                return {
                  ...target,
                  points,
                };
              })
            );

            return buildFocusTrendInsights(
              focusResults
                .flatMap((result) => result.status === "fulfilled" ? [result.value] : []),
            );
          })(),
        ]);

        if (cancelled) return;

        setInsights({
          loading: false,
          resolved: true,
          needsReview,
          improvementNotes,
          recentFocusPoints: focusTrendPayload.recentFocusPoints,
          focusTrendSeries: focusTrendPayload.focusTrendSeries,
          focusTrendData: focusTrendPayload.focusTrendData,
          focusTrendItems: focusTrendPayload.focusTrendItems,
          focusTrendTargets: focusTrendPayload.focusTrendTargets,
          focusPointCountByMap: focusTrendPayload.focusPointCountByMap,
        });
      } catch (_) {
        if (!cancelled) {
          setInsights((current) => ({
            ...current,
            loading: false,
            resolved: true,
          }));
        }
      }
    }

    void loadOverviewInsights();

    return () => {
      cancelled = true;
    };
  }, [
    focusTargetSignature,
    focusTargets,
    maps,
    normalizedCurrentUsername,
    noteMapIds,
    noteMapSignature,
    reviewTargetSignature,
    reviewTargets,
    team?.id,
  ]);

  const needsReviewCards = useMemo(() => insights.needsReview.flatMap(item => {
    const live = reviewTargets.find(target => target.key === item.key);
    return live ? [{...item, ...live}] : [];
  }), [insights.needsReview, reviewTargets]);

  const isLoading = authLoading || teamLoading || workspaceLoading;

  if (authLoading || teamLoading) {
    return (
      <div ref={pageRef} className="desktop-page desktop-page--overview">
      <section className="desktop-section desktop-overview-b overview-workspace">
          <div className="desktop-review-card desktop-overview-b__card">
            <div className="desktop-empty-copy">Loading Home...</div>
          </div>
        </section>
      </div>
    );
  }

  if (!userData?.uid) {
    return (
      <LoginTeamGate
        requireTeam={false}
        loginMessage="Please Login to access this page."
      />
    );
  }

  return (
    <div ref={pageRef} className="desktop-page desktop-page--overview">
        {route.prep&&userData?.uid&&<HomeEventPrep key={JSON.stringify([userData.uid,route.navigation.teamId||teamId,route.prep])} teamId={route.navigation.teamId||teamId} target={route.prep} onClose={()=>{const params=new URLSearchParams(location.search);params.delete('prep');params.delete('event');navigate({pathname:location.pathname,search:params.toString()?'?'+params.toString():''},{replace:true});}}/>}
      <section className="desktop-section desktop-overview-b overview-workspace" data-overview-mode={overviewMode} data-attention-layout="persistent">
        <div className="desktop-overview-b__topline">
          <div className="desktop-overview-b__topline-copy">
            <h2>{currentUsername} Home</h2>
          </div>
        </div>

        <div className="overview-mode-navigation"><div className="overview-mode-tabs" role="tablist" aria-label="Home section">
          {['Workspace', 'Coach', 'Manager'].map((label, index, labels) => {
            const id = label.toLowerCase();
            return <button key={id} type="button" role="tab" id={`overview-tab-${id}`}
              aria-selected={overviewMode === id} aria-controls={`overview-panel-${id}`}
              tabIndex={overviewMode === id ? 0 : -1} onClick={() => setOverviewMode(id)}
              onKeyDown={event => {
                const next = event.key === 'Home' ? 0 : event.key === 'End' ? labels.length - 1
                  : event.key === 'ArrowRight' ? (index + 1) % labels.length
                  : event.key === 'ArrowLeft' ? (index + labels.length - 1) % labels.length : null;
                if (next === null) return;
                event.preventDefault();
                setOverviewMode(labels[next].toLowerCase());
                event.currentTarget.parentElement.children[next].focus();
              }}>{label}</button>;
          })}
        </div><div className="overview-coach-controls-slot" ref={setCoachControlsTarget} hidden={overviewMode!=='coach'}/></div>

        {error ? (
          <article className="desktop-review-card desktop-overview-b__card desktop-overview-b__card--error">
            <div className="desktop-empty-copy">{error}</div>
          </article>
        ) : null}

        <AccountAttentionRail key={userData.uid} uid={userData.uid} username={currentUsername} teamId={teamId} teamName={team?.name||team?.teamName} perspective={overviewMode}/>
        <div className="overview-mode-panel" role="tabpanel" id="overview-panel-workspace" aria-labelledby="overview-tab-workspace" hidden={overviewMode !== 'workspace'}>
        <OverviewWeeklyEvents navigation={route.navigation} onNavigationConsumed={key=>{const params=new URLSearchParams(location.search);params.delete(key);navigate({pathname:location.pathname,search:params.toString()?"?"+params.toString():""},{replace:true});}} sidebarTarget={contextRail} active={overviewMode==='workspace'} workspaceMode={workspaceScheduleMode} onWorkspaceModeChange={setWorkspaceScheduleMode} onNavigateAvailability={navigateAvailability} participationHighlight={highlightParticipation} onParticipationHighlightChange={setHighlightParticipation}/>
        <div className="overview-rail-stack">
          <aside ref={setContextRail} className="overview-context-rail" aria-label={workspaceScheduleMode==='personal'?'Personal availability tools':'Calendar tools'}/>
        </div>
        </div>
        <div className="overview-mode-panel" role="tabpanel" id="overview-panel-coach" aria-labelledby="overview-tab-coach" hidden={overviewMode !== 'coach'}>
        <div className="overview-bottom-row coach-dashboard-host">
          {overviewMode==='coach'&&!teamId&&<p role="status">Select or create a team to use the Coach workspace. <Link to="/team-center/dashboard">Open Team Center</Link></p>}
          {overviewMode==='coach'&&teamId&&<CoachDashboard key={JSON.stringify([userData?.uid,teamId])} uid={userData?.uid} teamId={teamId} controlsTarget={coachControlsTarget}
            team={team} maps={maps} username={currentUsername} zone={userData?.lastActiveTimeZone||team?.teamTimeZone||'UTC'}
            insights={insights} reviewTargets={reviewTargets} needsReview={needsReviewCards} loading={isLoading||insights.loading} Chart={FocusTrendChart}/>}
        </div>
        </div>
        <div className="overview-mode-panel" role="tabpanel" id="overview-panel-manager" aria-labelledby="overview-tab-manager" hidden={overviewMode !== 'manager'}>
          {overviewMode==='manager'&&<ManagerBoard navigation={managerNavigation} participationHighlight={highlightParticipation} onParticipationHighlightChange={setHighlightParticipation}/>}
        </div>
      </section>
    </div>
  );
}
